var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlizzy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 640,
    viewBox: "0 0 553 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bg-color-1",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3b82f6",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "bg"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "bg-color-2",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6366f1",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "bg"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "bg-color-3",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a855f7",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "bg"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.282 360)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 0 400)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 69.282 440)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 138.282 400)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 69.282 440)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 138.282 480)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.282 280)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 0 320)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 69.282 360)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.282 200)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 0 240)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 69.282 280)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 276.282 0)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 207 40)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 276.282 80)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 207.282 40)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 138 80)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 207.282 120)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 138.282 80)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 69.282 120)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 138.282 160)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 69.282 120)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 0 160)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 69.282 200)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 483.282 360)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 414 400)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 483.282 440)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 483.282 280)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 414 320)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 483.282 360)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 207.282 440)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 138 480)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 207.282 520)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 483.282 200)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 414 240)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 483.282 280)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 483.282 120)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 414 160)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 483.282 200)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 414.282 160)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 345 200)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 414.282 240)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 414.282 400)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 345 440)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 414.282 480)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 345.282 200)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 276 240)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 345.282 280)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 276.282 240)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 207 280)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 276.282 320)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 345.282 440)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 276 480)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 345.282 520)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 276.282 480)",
    fill: "transparent",
    filter: "url(#bg-color-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 0.5 0 1 207 520)",
    fill: "transparent",
    filter: "url(#bg-color-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "matrix(0.866025 -0.5 0 1 276.282 560)",
    fill: "transparent",
    filter: "url(#bg-color-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlizzy);
export default __webpack_public_path__ + "static/media/glizzy.27fee8f3b0153e383009841d8f9c0eea.svg";
export { ForwardRef as ReactComponent };